module.exports = __webpack_public_path__ + "static/media/group-group.e94b2338.svg";